import papa from 'papaparse'
import React from 'react'
import Body from './Body'
import Footer from './Footer'

const useGetInternalSingleCityBasicTrackingPopup = ({
  onConfirm,
  onClose,
  isCanBeConfirmed,
  setCriticalError,
  setFile,
  error,
  setCodesTable,
  setWarning,
  isCodesUploading,
}) => {
  const title = 'Upload codes file'

  const onFileUpload = (entryFiles, ...rest) => {
    setCriticalError(null)
    setWarning(null)
    if (entryFiles.length) {
      setFile(entryFiles[0])
      papa.parse(entryFiles[0], {
        complete: function(results, file) {
          const data = results.data
          const codesArray = []

          data.forEach((dataItem, rowIndex) => {
            if (rowIndex === 0) {
              return
            }
            const code = dataItem[0]
            const city = dataItem[1]
            if (code || city) {
              codesArray.push(code || '')
            }
          })

          //Validate that required headers exist in file in A1:C1:
          if (data[0][0].trim().toUpperCase() !== 'FLYER CODE') {
            setCriticalError(
              'Header value missing or incorrect. Please follow the instructions in the template and try again.',
            )
            return
          }

          //If file does not contain any required values:
          if (!codesArray.length) {
            setCriticalError(
              'No codes or links found in file. Please review and try again.',
            )
            return
          }

          if (codesArray.find(code => code.length > 12)) {
            setCriticalError('Codes can not be longer than 12 characters.')
            return
          }

          const uniqueCodes = Array.from(new Set(codesArray))
          if (codesArray.length !== uniqueCodes.length) {
            setCriticalError('Caution: file contains duplicate codes.')
            return
          }

          setCodesTable(data)
        },
      })
    }
  }
  return {
    body: (
      <Body
        error={error}
        onFileUpload={onFileUpload}
        setError={setCriticalError}
        setFile={setFile}
      />
    ),
    footer: (
      <Footer
        onConfirm={onConfirm}
        onClose={onClose}
        isCanBeConfirmed={isCanBeConfirmed}
        isCodesUploading={isCodesUploading}
      />
    ),
    title: title,
  }
}

export default useGetInternalSingleCityBasicTrackingPopup
